import { render, staticRenderFns } from "./ConnectionSupportModal.vue?vue&type=template&id=9457928c&"
import script from "./ConnectionSupportModal.vue?vue&type=script&lang=ts&"
export * from "./ConnectionSupportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports